import { render, staticRenderFns } from "./Documentary.vue?vue&type=template&id=3501ad75&"
import script from "./Documentary.vue?vue&type=script&lang=js&"
export * from "./Documentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports